import React, {Component} from 'react'
import {
  Box,
  Button,
  Heading,
  Text,
  VStack,
  Grid,
  GridItem,
  HStack,
  Badge,
  Input,
  InputGroup,
  InputLeftElement,
  Icon,
  Checkbox,
  Tooltip,
  Card,
  CardBody,
  useBreakpointValue
} from '@chakra-ui/react';
import { FiSearch } from 'react-icons/fi';
import './AlleSuggesties.css'
import Sidebar from '../Sidebar/Sidebar';
import Navigation from '../../Navigation/Navigation';
import MobileMenu from '../MobileMenu/MobileMenu';
import Footer from '../../../components/Footer/Footer';

class AlleSuggesties extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobileMenuOpen: false,
      searchKeyword: '',
      filteredSuggestions: null,
      hideNotSerious: false
    };
  }
  
  componentDidMount() {
    // Load all suggestions when component mounts
    if (this.props.loadAllSuggestions) {
      this.props.loadAllSuggestions();
    }
    this.applyTrendingTopicFilter();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.state.trendingTopicFilter !== this.props.state.trendingTopicFilter) {
      this.applyTrendingTopicFilter();
    }
  }

  applyTrendingTopicFilter = () => {
    const trendingFilter = this.props.state.trendingTopicFilter;
    if (!trendingFilter) {
      this.setState({ filteredSuggestions: null });
      return;
    }

    const allSuggestions = this.props.state.allSuggestions || { items: [] };

    // Use the suggestion IDs from the trending topic if available
    if (trendingFilter.suggestion_ids && trendingFilter.suggestion_ids.length > 0) {
      const filtered = allSuggestions.items.filter(suggestion =>
        trendingFilter.suggestion_ids.includes(suggestion.id)
      );

      this.setState({ 
        filteredSuggestions: {
          ...allSuggestions,
          items: filtered
        }
      });
    } else {
      // Fallback to keyword matching if IDs not available
      const topicKeywords = this.getKeywordsForTopic(trendingFilter.topic);

      const filtered = allSuggestions.items.filter(suggestion => {
        const text = suggestion.text.toLowerCase();
        return topicKeywords.some(keyword => text.includes(keyword));
      });

      this.setState({ 
        filteredSuggestions: {
          ...allSuggestions,
          items: filtered
        }
      });
    }
  }

  getKeywordsForTopic = (topic) => {
    // Mirror the backend topic categories and keywords exactly
    const topicCategories = {
      'Verkeersveiligheid en Mobiliteit': [
        'fiets', 'auto', 'verkeer', 'weg', 'straat', 'parkeren', 'gevaarlijk',
        'onveilig', 'kruising', 'rotonde', 'snelheid', '30 km', 'fietspad',
        'voetganger', 'zebrapad', 'verkeerslicht', 'bus', 'halte', 'station'
      ],
      'Groen en Leefomgeving': [
        'boom', 'park', 'groen', 'natuur', 'speelplaats', 'hond', 'rommel',
        'afval', 'schoon', 'onderhoud', 'gras', 'bloemen', 'bank', 'bankje',
        'wandelpad', 'sport', 'sportveld'
      ],
      'Openbare Voorzieningen': [
        'toilet', 'wc', 'verlichting', 'lamp', 'donker', 'licht', 'prullenbak',
        'container', 'recycling', 'glasbak', 'openbaar', 'toegankelijk',
        'bankje', 'zitplek'
      ],
      'Jeugd en Onderwijs': [
        'kinderen', 'jeugd', 'school', 'speelplaats', 'speeltuin', 'sport',
        'voetbal', 'basketbal', 'jongeren', 'activiteit', 'onderwijs',
        'bibliotheek'
      ],
      'Overlast en Veiligheid': [
        'overlast', 'geluid', 'lawaai', 'muziek', 'schreeuwen', 'politie',
        'vandalisme', 'graffiti', 'inbraak', 'diefstal', 'hangjongeren',
        'alcohol', 'drugs', 'agressie'
      ],
      'Infrastructuur en Onderhoud': [
        'kapot', 'repareren', 'onderhoud', 'gat', 'stoep', 'tegels', 'losliggend',
        'gevaarlijk', 'instorten', 'beschadigd', 'vervangen', 'vernieuwen',
        'slecht', 'oud'
      ],
      'Bereikbaarheid en Toegankelijkheid': [
        'rolstoel', 'toegankelijk', 'mindervalid', 'ouderen', 'trappen',
        'lift', 'helling', 'drempel', 'bereikbaar', 'moeilijk', 'helpen'
      ],
      'Economie en Lokale Handel': [
        'winkel', 'markt', 'bedrijf', 'economie', 'werkgelegenheid', 'baan',
        'ondernemer', 'lokaal', 'centrum', 'leegstand', 'huur'
      ],
      'Wonen en Huisvesting': [
        'woningen', 'huis', 'huizen', 'wonen', 'huur', 'koop', 'appartement',
        'sociale huur', 'betaalbaar', 'huizenmarkt', 'huizentekort'
      ],
      'Overig': []
    };

    // For "Overig" category, fall back to sample suggestions matching
    if (topic === 'Overig' && this.props.state.trendingTopicFilter.sample_suggestions) {
      return this.props.state.trendingTopicFilter.sample_suggestions.map(s => s.toLowerCase());
    }

    return topicCategories[topic] || [];
  }
  
  handleSearchChange = (event) => {
    const keyword = event.target.value;
    this.setState({ searchKeyword: keyword });
    
    if (keyword.trim() === '') {
      this.setState({ filteredSuggestions: null });
      return;
    }
    
    const allSuggestions = this.props.state.allSuggestions || { items: [] };
    const filtered = allSuggestions.items.filter(suggestion =>
      suggestion.text.toLowerCase().includes(keyword.toLowerCase()) ||
      (suggestion.username && suggestion.username.toLowerCase().includes(keyword.toLowerCase())) ||
      (suggestion.guest_email && suggestion.guest_email.toLowerCase().includes(keyword.toLowerCase()))
    );
    
    this.setState({ 
      filteredSuggestions: {
        ...allSuggestions,
        items: filtered
      }
    });
  }

  handleOpenMobileMenu = () => {
    this.setState({ isMobileMenuOpen: true })
  }

  handleCloseMobileMenu = () => {
    this.setState({ isMobileMenuOpen: false })
  }

  handleToggleHideNotSerious = () => {
    this.setState({ hideNotSerious: !this.state.hideNotSerious })
  }

  componentWillUnmount() {
    // Ensure mobile menu is closed when component unmounts
    if (this.state.isMobileMenuOpen) {
      this.setState({ isMobileMenuOpen: false })
    }
  }

  render () {
    let allSuggestions = this.state.filteredSuggestions || this.props.state.allSuggestions || { items: [], page: 0 };

    // Hide not serious suggestions if filter is enabled
    if (this.state.hideNotSerious) {
      allSuggestions = {
        ...allSuggestions,
        items: allSuggestions.items.filter(suggestion => suggestion.marked_not_serious !== true)
      };
    }

    const isFiltering = this.state.searchKeyword.trim() !== '';
    const trendingFilter = this.props.state.trendingTopicFilter;
    const isTrendingFiltering = trendingFilter !== null;

    return (
      <>
        <Grid templateColumns="repeat(24, 1fr)" bg="gray.50" minHeight="100vh">
        {/* sidebar */}
        <GridItem
          as="aside"
          colSpan={{ base: 0, md: 4, lg: 3 }}
          display={{ base: "none", md: "block" }}
          bg="gray.50"
          minHeight={{ lg: '100vh' }}
          p={0}
        >
        <Sidebar
        getFeed = {this.props.getFeed}
        onRouteChange = {this.props.onRouteChange}
        userVersion = {this.props.state.userVersion}
        resetSuggestionsPage = {this.props.resetSuggestionsPage}
        onLogout = {this.props.onLogout}
        />
        </GridItem>
        <GridItem
        as="main"
        colSpan={{ base: 24, md: 20, lg: 21 }}
        p={{ base: "8px", md: "10px" }}
        display="flex"
        flexDirection="column"
        minHeight="100vh"
        >
        <Navigation
        state = {this.props.state}
        onRouteChange = {this.props.onRouteChange}
        getFeed = {this.props.getFeed}
        onVersionChange = {this.props.onVersionChange}
        onLogout = {this.props.onLogout}
        onOpenFeedback = {this.props.onOpenFeedback}
        onOpenMobileMenu = {this.handleOpenMobileMenu}
        />

        <Box p={{ base: "16px", md: "40px" }} flex="1">
          <VStack spacing={6} align="stretch">
            <Heading as="h2" size={{ base: "md", md: "lg" }} textAlign="center" color="gray.600">
              {isTrendingFiltering ? `Suggesties: ${trendingFilter.topic}` : 'Alle Suggesties'}
            </Heading>

            <Text color="gray.500" textAlign="center" fontSize={{ base: "sm", md: "md" }}>
              {isTrendingFiltering ?
                `Gefilterd op trending topic: "${trendingFilter.topic}"` :
                'Bekijk alle ingediende suggesties van inwoners'
              }
            </Text>

            {isTrendingFiltering && (
              <Box textAlign="center">
                <Button
                  onClick={this.props.onClearTrendingFilter}
                  colorScheme="blue"
                  variant="outline"
                  size="sm"
                >
                  Filter wissen - Toon alle suggesties
                </Button>
              </Box>
            )}

            {/* Search Filter */}
            <VStack spacing={3} align="stretch">
              <Box maxWidth={{ base: "100%", md: "400px" }} width="100%" mx="auto">
                <InputGroup>
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FiSearch} color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Zoek suggesties of gebruikers..."
                    value={this.state.searchKeyword}
                    onChange={this.handleSearchChange}
                    bg="white"
                    borderRadius="md"
                    shadow="sm"
                  />
                </InputGroup>
              </Box>

              {/* Hide Not Serious Checkbox */}
              <Box textAlign="center">
                <Checkbox
                  isChecked={this.state.hideNotSerious}
                  onChange={this.handleToggleHideNotSerious}
                  colorScheme="green"
                  size="md"
                >
                  <Text fontSize="sm">Alleen serieuze suggesties</Text>
                </Checkbox>
              </Box>
            </VStack>

            {(isFiltering || isTrendingFiltering || this.state.hideNotSerious) && (
              <Text fontSize="sm" color="gray.600" textAlign="center">
                {allSuggestions.items.length} resultaten gevonden
                {isFiltering && ` voor "${this.state.searchKeyword}"`}
                {isTrendingFiltering && !isFiltering && ` voor trending topic "${trendingFilter.topic}"`}
                {this.state.hideNotSerious && !isFiltering && !isTrendingFiltering && ` (alleen serieus)`}
              </Text>
            )}
            
            {allSuggestions.items && allSuggestions.items.length > 0 ? (
              <VStack spacing={4} align="stretch">
                {/* Card View for all screen sizes */}
                <VStack spacing={3} align="stretch">
                  {allSuggestions.items.map((suggestion, index) => (
                    <SuggestionCard
                      key={suggestion.id || index}
                      suggestion={suggestion}
                      onStatusUpdate={this.props.onSuggestionStatusUpdate}
                      onSuggestionSelect={this.props.onSuggestionSelect}
                      isMobile={this.props.isMobile}
                    />
                  ))}
                </VStack>

                {/* Pagination - only show when not filtering */}
                {!isFiltering && !isTrendingFiltering && (
                  <Box textAlign="center" mt={6}>
                    <HStack justify="center" spacing={4}>
                      <Button
                        disabled={!allSuggestions.hasPrev}
                        isDisabled={!allSuggestions.hasPrev}
                        onClick={() => {
                          if (allSuggestions.hasPrev && this.props.onPaginationButtonClick) {
                            this.props.onPaginationButtonClick('Previous', 'allSuggestions');
                          }
                        }}
                        bg="blue.400"
                        color="white"
                        _hover={{ bg: 'blue.500' }}
                        _disabled={{ bg: 'gray.300', color: 'gray.500', cursor: 'not-allowed' }}
                      >
                        Vorige
                      </Button>
                      <Text color="gray.500">
                        Pagina {allSuggestions.page + 1}
                      </Text>
                      <Button
                        disabled={!allSuggestions.hasNext}
                        isDisabled={!allSuggestions.hasNext}
                        onClick={() => {
                          if (allSuggestions.hasNext && this.props.onPaginationButtonClick) {
                            this.props.onPaginationButtonClick('Next', 'allSuggestions');
                          }
                        }}
                        bg="blue.400"
                        color="white"
                        _hover={{ bg: 'blue.500' }}
                        _disabled={{ bg: 'gray.300', color: 'gray.500', cursor: 'not-allowed' }}
                      >
                        Volgende
                      </Button>
                    </HStack>
                  </Box>
                )}
              </VStack>
            ) : (
              <Box textAlign="center" py={12}>
                <Text fontSize="lg" color="gray.500">
                  {isFiltering ? 
                    `Geen suggesties gevonden voor "${this.state.searchKeyword}"` :
                    isTrendingFiltering ?
                    `Geen suggesties gevonden voor trending topic "${trendingFilter.topic}"` :
                    'Er zijn nog geen suggesties ingediend'
                  }
                </Text>
                {(isFiltering || isTrendingFiltering) && (
                  <Button
                    mt={4}
                    onClick={() => {
                      this.setState({ searchKeyword: '', filteredSuggestions: null });
                      if (isTrendingFiltering && this.props.onClearTrendingFilter) {
                        this.props.onClearTrendingFilter();
                      }
                    }}
                    colorScheme="blue"
                    variant="outline"
                    size="sm"
                  >
                    {isTrendingFiltering && !isFiltering ? 'Filter wissen' : 'Filters wissen'}
                  </Button>
                )}
              </Box>
            )}
          </VStack>
        </Box>
        <Footer onRouteChange={this.props.onRouteChange} />

        </GridItem>
        </Grid>

        {/* Mobile Menu Drawer */}
        <MobileMenu
          isOpen={this.state.isMobileMenuOpen}
          onClose={this.handleCloseMobileMenu}
          onRouteChange={this.props.onRouteChange}
          userVersion={this.props.state.userVersion}
          resetSuggestionsPage={this.props.resetSuggestionsPage}
          onLogout={this.props.onLogout}
        />
      </>
    )
  }
}

// Card Component for Suggestions (all screen sizes)
class SuggestionCard extends Component {
  handleStatusChange = (newStatus) => {
    if (this.props.onStatusUpdate) {
      this.props.onStatusUpdate(this.props.suggestion.id, newStatus);
    }
  }

  render() {
    const { suggestion } = this.props;

    const getStatusColor = (status) => {
      switch(status) {
        case 'submitted': return 'green';
        case 'reviewed': return 'yellow';
        case 'implemented': return 'blue';
        default: return 'gray';
      }
    }

    const getStatusText = (status) => {
      switch(status) {
        case 'submitted': return 'Ingediend';
        case 'reviewed': return 'Bekeken';
        default: return 'Onbekend';
      }
    }

    const cardContent = (
      <Card
        w="100%"
        bg={suggestion.marked_not_serious ? 'red.50' : 'white'}
        opacity={suggestion.marked_not_serious ? 0.8 : 1}
        borderLeft={suggestion.marked_not_serious ? '4px solid' : 'none'}
        borderLeftColor={suggestion.marked_not_serious ? 'red.400' : 'transparent'}
        shadow="sm"
        _hover={{ shadow: 'md' }}
        transition="all 0.2s"
      >
        <CardBody>
          {this.props.isMobile ? (
            <VStack align="stretch" spacing={3}>
              {/* Header: ID and Status */}
              <HStack justify="space-between" w="100%">
                <HStack spacing={2}>
                  <Text fontSize="sm" color="gray.600" fontWeight="medium">
                    #{suggestion.id}
                  </Text>
                  {suggestion.is_guest && (
                    <Badge colorScheme="purple" fontSize="xs">Gast</Badge>
                  )}
                </HStack>
                <Badge
                  colorScheme={getStatusColor(suggestion.status)}
                  variant="solid"
                  fontSize="xs"
                >
                  {getStatusText(suggestion.status)}
                </Badge>
              </HStack>

              {/* User */}
              {!suggestion.is_guest && (
                <Text fontWeight="semibold" color="gray.700" fontSize="sm">
                  {suggestion.username || 'Onbekend'}
                </Text>
              )}

              {/* Suggestion Text */}
              <Text
                color="blue.600"
                fontSize="sm"
                noOfLines={4}
                cursor="pointer"
                _hover={{ color: 'blue.800' }}
                onClick={() => this.props.onSuggestionSelect && this.props.onSuggestionSelect(suggestion)}
              >
                {suggestion.text}
              </Text>

              {/* Date */}
              <Text fontSize="xs" color="gray.500">
                {suggestion.created_at ?
                  new Date(suggestion.created_at).toLocaleDateString('nl-NL', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  }) :
                  'Onbekend'}
              </Text>

              {/* Action Button */}
              {suggestion.status === 'submitted' && (
                <Button
                  size="sm"
                  colorScheme="yellow"
                  onClick={() => this.handleStatusChange('reviewed')}
                  width="100%"
                >
                  Markeer als bekeken
                </Button>
              )}

              {suggestion.status === 'reviewed' && (
                <HStack justify="center">
                  <Text fontSize="sm" color="green.500" fontWeight="semibold">
                    ✓ Bekeken
                  </Text>
                </HStack>
              )}

              {/* Not Serious Warning */}
              {suggestion.marked_not_serious && (
                <Text fontSize="xs" color="red.600" fontStyle="italic">
                  ⚠ Gemarkeerd als niet serieus
                </Text>
              )}
            </VStack>
          ) : (
            /* Desktop: Horizontal layout */
            <VStack align="stretch" spacing={3}>
              {/* Header Row: ID, User, Status */}
              <HStack justify="space-between" w="100%">
                <HStack spacing={4}>
                  <Text fontSize="sm" color="gray.600" fontWeight="bold">
                    #{suggestion.id}
                  </Text>
                  {suggestion.is_guest ? (
                    <Badge colorScheme="purple" fontSize="xs">Gast</Badge>
                  ) : (
                    <Text fontWeight="semibold" color="gray.700" fontSize="sm">
                      {suggestion.username || 'Onbekend'}
                    </Text>
                  )}
                  <Text fontSize="sm" color="gray.500">
                    {suggestion.created_at ?
                      new Date(suggestion.created_at).toLocaleDateString('nl-NL', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric'
                      }) :
                      'Onbekend'}
                  </Text>
                </HStack>
                <HStack spacing={3}>
                  <Badge
                    colorScheme={getStatusColor(suggestion.status)}
                    variant="solid"
                    fontSize="xs"
                  >
                    {getStatusText(suggestion.status)}
                  </Badge>
                  {suggestion.status === 'submitted' && (
                    <Button
                      size="sm"
                      colorScheme="yellow"
                      onClick={() => this.handleStatusChange('reviewed')}
                    >
                      Markeer als bekeken
                    </Button>
                  )}
                  {suggestion.status === 'reviewed' && (
                    <Text fontSize="sm" color="green.500" fontWeight="semibold">
                      ✓ Bekeken
                    </Text>
                  )}
                </HStack>
              </HStack>

              {/* Suggestion Text */}
              <Text
                color="blue.600"
                fontSize="md"
                noOfLines={3}
                cursor="pointer"
                _hover={{ color: 'blue.800', textDecoration: 'underline' }}
                onClick={() => this.props.onSuggestionSelect && this.props.onSuggestionSelect(suggestion)}
              >
                {suggestion.text}
              </Text>

              {/* Not Serious Warning */}
              {suggestion.marked_not_serious && (
                <HStack>
                  <Text fontSize="xs" color="red.600" fontStyle="italic">
                    ⚠ Gemarkeerd als niet serieus
                  </Text>
                </HStack>
              )}
            </VStack>
          )}
        </CardBody>
      </Card>
    );

    return suggestion.marked_not_serious ? (
      <Tooltip label="Deze Suggestie is gemarkeerd als Niet Serieus" placement="top" hasArrow>
        {cardContent}
      </Tooltip>
    ) : cardContent;
  }
}

// Wrapper to inject breakpoint value into class component
function AlleSuggestiesWrapper(props) {
  const isMobile = useBreakpointValue({ base: true, md: false });
  return <AlleSuggesties {...props} isMobile={isMobile} />;
}

export default AlleSuggestiesWrapper